import React from 'react';
import cx from 'classnames';
import usePortal from 'react-useportal'

import { Icon } from '@iconify/react';
import iconClose from '@iconify-icons/mdi/close';

function Alert({ children, layout, onClose }) {

  const { Portal } = usePortal({
    bindTo: document && document.getElementById('checkout-alert')
  })

  return (
    <Portal>
      <div className="grid-container">
        <div className="grid-x grid-margin-x ">
          <section className="cell xlarge-12 login-column">
            <div className={cx("Alert__message", `Alert__message--${layout}`)} role="alert">
              <div>{children}</div>
              <Icon icon={iconClose} onClick={onClose} className={cx('icon')} />
            </div>
          </section>
        </div>
      </div>
    </Portal>
  );
}

export default Alert;
